import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as echarts from "echarts";
import Ocharts from "./ochart.js";
import ReportApi from "@api/report";
import moment from "moment";

/**
 * ======== UI组件
 */
import Title from "../components/Title";
import CommonlyChart from "../components/charts";
import ScrollNumber from "../components/ScrollNumber";
import Divider from "../components/Divider";
import SubTitle from "../components/Title/subTitle";
import Tab from "../components/Tab";
import Block from "../components/Block";
import Block2 from "../components/Block/Block2";

/**
 * ====== redux
 */
/**
 * ======== api
 */
import API from "../api/screen";
import AnalysisApi from "@/api/analysis";
/**
 * ======== 图片引用
 */
import middleIcon from "../assets/middleIcon.png";
import bottomIcon from "../assets/bottomIcon.png";
import topIcon from "../assets/topIcon.png";

import static_01 from "../assets/static_01.png";
import static_02 from "../assets/static_02.png";
import static_03 from "../assets/static_03.png";

import "./left.scss";

const Index = ({ dispatch, showLeft, lx }) => {
  const [data, setData] = useState({}); //信息总览
  const [shuizhi, setShuizhi] = useState([
    //厂站水质达标趋势图-左边数据
    "COD",
    "NH3-N",
    "TP",
    "TN",
    "PH",
  ]);
  const [xunjian_data, setXunjian_data] = useState([
    [{ label: "任务总数", value: "-" }],
    [
      { label: "未处理", value: "-" },
      { label: "处理中", value: "-" },
      { label: "已完成", value: "-" },
      { label: "漏检", value: "-" },
    ],
  ]);

  // 巡检任务统计接口对接
  const fetchPatrolTaskItemStatistics = () => {
    AnalysisApi.getPatrolTaskItemStatistics({
      stationId: "61",
      startTime: '1999-01-01',
      endTime: '3000-01-01',
    }).then((res) => {
      if (res.status === "0" && res.data) {
        setXunjian_data([
          [{ label: "任务总数", value: res.data.totalNumber ?? 0 }],
          [
            { label: "未处理", value: res.data.unhandleNumber ?? 0 },
            { label: "处理中", value: res.data.handlingNumber ?? 0 },
            { label: "已完成", value: res.data.finishNumber ?? 0 },
            { label: "漏检", value: res.data.leakNumber ?? 0 },
          ],
        ]);
        seOption(
          [
            { name: "未处理", value: res.data.unhandleNumber ?? 0 },
            { name: "处理中", value: res.data.handlingNumber ?? 0 },
            { name: "已完成", value: res.data.finishNumber ?? 0 },
            { name: "漏检", value: res.data.leakNumber ?? 0 },
          ],
          ["#4C87FF", "#5AD8A6", "#F6BD16", "#EB7464"],
          setXunjian_option,
        );
      }
    });
  };
  const [quexian_data, setquexian_data] = useState([
    [{ label: "缺陷单总数", value: "-" }],
    [
      { label: "未处理", value: "-" },
      { label: "处理中", value: "-" },
      { label: "超时", value: "-" },
      { label: "已完成", value: "-" },
    ],
  ]);
  // 缺陷单统计接口对接
  const fetchDefectOrderStatistics = () => {
    AnalysisApi.getDefectOrderStatistics({
      stationId: "61",
      startTime: '1999-01-01',
      endTime: '3000-01-01',
    }).then((res) => {
      if (res.status === "0" && res.data) {
        setquexian_data([
          [{ label: "缺陷单总数", value: res.data.totalNumber ?? 0 }],
          [
            { label: "未处理", value: res.data.unhandleNumber ?? 0 },
            { label: "处理中", value: res.data.handlingNumber ?? 0 },
            { label: "超时", value: res.data.timeoutNumber ?? 0 },
            { label: "已完成", value: res.data.finishNumber ?? 0 },
          ],
        ]);
        seOption(
          [
            { name: "未处理", value: res.data.unhandleNumber ?? 0 },
            { name: "处理中", value: res.data.handlingNumber ?? 0 },
            { name: "超时", value: res.data.timeoutNumber ?? 0 },
            { name: "已完成", value: res.data.finishNumber ?? 0 },
          ],
          ["#44D2F1", "#EB7464", "#EBB855", "#5AD8A6"],
          setXunjian_option2,
        );
      }
    });
  };
  const [gongdan_data, setgongdan_data] = useState([
    [{ label: "工单总数", value: "-" }],
    [
      { label: "未处理", value: "-" },
      { label: "处理中", value: "-" },
      { label: "超时", value: "-" },
      { label: "已完成", value: "-" },
    ],
  ]);

  // 工单统计接口对接
  const fetchPatrolWorkOrderStatistics = () => {
    AnalysisApi.getPatrolWorkOrderStatistics({
      stationId: "61",
      startTime: '1999-01-01',
      endTime: '3000-01-01',
    }).then((res) => {
      if (res.status === "0" && res.data) {
        setgongdan_data([
          [{ label: "工单总数", value: res.data.totalNumber ?? 0 }],
          [
            { label: "未处理", value: res.data.unhandleNumber ?? 0 },
            { label: "处理中", value: res.data.handlingNumber ?? 0 },
            { label: "超时", value: res.data.timeoutNumber ?? 0 },
            { label: "已完成", value: res.data.finishNumber ?? 0 },
          ],
        ]);
        seOption(
          [
            { name: "未处理", value: res.data.unhandleNumber ?? 0 },
            { name: "处理中", value: res.data.handlingNumber ?? 0 },
            { name: "超时", value: res.data.timeoutNumber ?? 0 },
            { name: "已完成", value: res.data.finishNumber ?? 0 },
          ],
          ["#4C87FF", "#5AD8A6", "#EBB855", "#EB7464"],
          setXunjian_option3,
        );
      }
    });
  };
  const [device_data, setdevice_data] = useState([
    //设备
    [{ label: " ", value: " " }],
    [
      { label: "设备总数", value: "100" },
      { label: "维修中", value: "0" },
    ],
  ]);
  const [xunjian_option, setXunjian_option] = useState({}); //巡检option
  const [xunjian_option2, setXunjian_option2] = useState({}); //缺陷单option
  const [xunjian_option3, setXunjian_option3] = useState({}); //工单option
  const [xunjian_option4, setXunjian_option4] = useState({}); //设备option
  const [shuizhi_option, setShuizhi_option] = useState({}); //水质达标趋势图 option
  const [shuizhi_active, setShuizhi_active] = useState(0); //水质达标趋势图 active
  const [shuizhi_click, setShuizhi_click] = useState(""); //水质达标趋势图 点击项
  const [nenghao_option, setNenghao_option] = useState({}); //能耗数据分析 option
  const [nenghaoActive, setNenghaoActive] = useState(0); //能耗数据分析 active
  const [isPoll, setIsPoll] = useState(true); //是否轮询

  //图表数据
  const [chartData, setChartData] = useState({});

  const findOutWaterQuality = () => {
    let data = {
      queryTimeStartStr: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      queryTimeEndStr: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      reportType: 1,
      inOrOut: 2,
      cod: 1,
      nh3n: 3,
      tn: 2,
      tp: 4,
      ss: 7,
      stationId: "61",
    };

    ReportApi.selectWaterQuality(data).then((res) => {
      if (res.status == 0 && res.data) {
        const { data } = res.data;
        setChartData({ data });
      }
    });
  };

  useEffect(() => {
    findOutWaterQuality();
    outWater();
    let i = setInterval(() => {
      findOutWaterQuality();
      outWater();
    }, 60 * 1000);
    return () => {
      clearInterval(i);
    };
  }, []);
  useEffect(() => {
    stationWaterQualityQualified();
  }, [shuizhi_active, shuizhi_click, isPoll]);

  useEffect(() => {
    selectDnbSurface();
    let i = setInterval(
      () => {
        selectDnbSurface();
      },
      24 * 60 * 60 * 1000,
    );
    return () => {
      clearInterval(i);
    };
  }, [nenghaoActive]);

  useEffect(() => {
    let interval = "";
    if (isPoll) {
      interval = setTimeout(
        () => {
          if (shuizhi_active < shuizhi.length - 1) {
            setShuizhi_active(shuizhi_active + 1);
          } else {
            setShuizhi_active(0);
          }
        },
        1 * 60 * 1000,
      );
    } else {
      interval && clearTimeout(interval);
    }
    return () => {
      clearTimeout(interval);
    };
  }, [shuizhi_active, isPoll]);

  useEffect(() => {
    fetchPatrolTaskItemStatistics();
    fetchDefectOrderStatistics();
    fetchPatrolWorkOrderStatistics();
    seOption(
      [
        { name: "完好率", value: 100 },
        { name: "维修中", value: 0 },
      ],
      ["#4C87FF", "#08213F"],
      setXunjian_option4,
    );
  }, []);

  //出水信息
  const outWater = () => {
    API.outWater({}).then((res) => {
      if (res.status == 0) {
        let data = {};
        for (let key in res.data) {
          data[key] = res.data[key] * 1;
        }
        setData(data);
      }
    });
  };
  // 厂站水质达标趋势图
  const stationWaterQualityQualified = () => {
    API.stationWaterQualityQualified({
      gisWaterQualityType: isPoll ? shuizhi_active + 1 : shuizhi_click + 1,
    }).then((res) => {
      if (res.status == 0) {
        let data = [];
        console.log(res.data, "ttttttt");
        res.data &&
          res.data.currData &&
          res.data.currData.map((item) => {
            if (item.parValue !== null) {
              data.push({
                label: item.aliasName || item.name,
                value: item.parValue && (item.parValue * 1).toFixed(3),
              });
            }
          });
        getShuizhi_option(data, res.data.qualifiedValue);
      }
    });
  };

  //厂站能耗数据分析
  const selectDnbSurface = () => {
    API.selectDnbSurface({ surfaceType: nenghaoActive + 1 }).then((res) => {
      if (res.status == 0) {
        let data = [];
        res.data &&
          res.data.map((item) => {
            if (item.val !== null) {
              data.push({
                label: item.stationAliasName || item.stationName,
                value: item.val,
              });
            }
          });
        getNenghao_option(data);
      }
    });
  };

  const seOption = (data = [], color = [], set) => {
    let option = {
      color: color || ["#4C87FF", "#5AD8A6", "#F6BD16"],
      tooltip: {
        trigger: "item",
      },
      // legend: {
      //   top: '5%',
      //   left: 'center'
      // },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["76%", "100%"],
          avoidLabelOverlap: false,
          emphasis: {
            //中间文字显示
            label: {
              show: true,
              align: "center",
              color: "#fff",
              formatter: "{label|{b}}" + "\n\r" + "{percent|{d}%}",
              // formatter: '{label|' + {a} + '}' + '\n\r' + '{percent|' + {d} + '}',
              rich: {
                label: {
                  fontSize: 12,
                  fontFamily: "BTZ",
                  color: "rgba(255, 255, 255, 0.65)",
                  lineHeight: 24,
                },
                percent: {
                  fontFamily: "BTZ",
                  fontSize: 16,
                  color: "#fff",
                },
              },
            },
          },
          label: {
            // normal: {
            show: false,
            position: "center",
            // },
          },
          hoverOffset: 0,
          labelLine: {
            show: false,
          },
          data: data,
          // [
          //   { value: 10, name: '居民用水' },
          //   { value: 20, name: '非居民用水' },
          //   { value: 40, name: '其他' },
          // ]
        },
      ],
    };
    set(option);
  };

  const getShuizhi_option = (data = [], qualifiedValue) => {
    let data1 = [];
    let data2 = [];
    let yAxis = [];
    data.map((item) => {
      yAxis.push(item.label);
      if (item.value > qualifiedValue * 1) {
        data1.push(qualifiedValue * 1);
        data2.push(item.value - qualifiedValue * 1);
      } else {
        data1.push(item.value);
        data2.push(0);
      }
    });
    let end = 100;
    end = Math.round((7 / data.length) * 100);
    let isShowZoom = data.length > 7 ? true : false;
    const option = {
      tooltip: {
        show: false,
        trigger: "axis",
        axisPointer: {
          // Use axis to trigger tooltip
          type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
        },
      },
      legend: {
        show: false,
      },
      grid: {
        left: "12%",
        right: "21%",
        top: "3%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      yAxis: {
        type: "category",
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        data: yAxis,
      },
      dataZoom: [
        {
          show: isShowZoom,
          zoomLock: true,
          showDetail: false,
          yAxisIndex: 0,
          filterMode: "empty",
          width: 14,
          height: "100%",
          showDataShadow: false,
          left: "1%",
          start: 0,
          end,
        },
      ],
      series: [
        {
          name: "正常",
          type: "bar",
          barWidth: 14,
          barGap: "50%",
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
              {
                offset: 0,
                color: "#143263",
              },
              {
                offset: 1,
                color: "#01BDFB",
              },
            ]),
          },
          stack: "total",
          label: {
            show: false,
          },
          emphasis: {
            focus: "none",
          },
          data: data1,
        },
        {
          name: "超出",
          type: "bar",
          barWidth: 14,
          stack: "total",
          label: {
            show: true,
            position: "right",
            formatter: (item) => {
              if (data[item.dataIndex].value > 100) {
                return "{b|" + data[item.dataIndex].value + "}";
              } else {
                return "{a|" + data[item.dataIndex].value + "}";
              }
            },
            rich: {
              a: {
                color: "#00C1FF",
              },
              b: {
                color: "#FF4A3E",
              },
            },
          },
          emphasis: {
            focus: "none",
          },
          itemStyle: {
            //柱形图圆角，初始化效果
            borderRadius: [0, 14, 14, 0],
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
              {
                offset: 0,
                color: "#FFAA60",
              },
              {
                offset: 1,
                color: "#FF3938",
              },
            ]),
          },
          data: data2,
        },
      ],
    };
    setShuizhi_option(option);
  };
  const getNenghao_option = (data = []) => {
    let data1 = [];
    let yAxis = [];
    data.map((item) => {
      yAxis.push(item.label);
      data1.push(item.value);
    });
    let end = 100;
    end = Math.round((7 / data.length) * 100);
    let isShowZoom = data.length > 7 ? true : false;
    const option = {
      tooltip: {
        show: false,
        trigger: "axis",
        axisPointer: {
          // Use axis to trigger tooltip
          type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
        },
      },
      legend: {
        show: false,
      },
      grid: {
        left: "12%",
        right: "14%",
        top: "3%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      yAxis: {
        type: "category",
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        data: yAxis,
      },
      dataZoom: [
        {
          show: isShowZoom,
          zoomLock: true,
          showDetail: false,
          yAxisIndex: 0,
          filterMode: "empty",
          width: 14,
          height: "100%",
          showDataShadow: false,
          left: "1%",
          start: 0,
          end,
        },
      ],
      series: [
        {
          name: "能耗统计",
          type: "bar",
          barWidth: 14,
          barGap: "50%",
          itemStyle: {
            //柱形图圆角，初始化效果
            borderRadius: [0, 14, 14, 0],
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
              {
                offset: 0,
                color: "#2B313F",
              },
              {
                offset: 1,
                color: "#FBC02A",
              },
            ]),
          },
          stack: "total",
          label: {
            show: true,
            position: "right",
            formatter: (item) => {
              return "{a|" + data[item.dataIndex].value + "}";
            },
            rich: {
              a: {
                color: "#FFC329",
              },
            },
          },
          emphasis: {
            focus: "series",
          },
          data: data1,
        },
      ],
    };
    setNenghao_option(option);
  };

  const changeIndex = (index) => {
    // setShuizhi_active(index);
    if (index === shuizhi_click) {
      setIsPoll(true);
      setShuizhi_click("");
    } else {
      setShuizhi_click(index);
      setIsPoll(false);
    }
  };
  const changeNenghaoActive = (index) => {
    setNenghaoActive(index);
  };

  return (
    <div className="left-wrap relative">
      <div className="relative">
        <Title title="信息总览" />
        <div className="production block_item">
          <div className="statisc flex alignItemCenter">
            <div className="relative">
              <img src={bottomIcon} alt="" className="bottomIcon" />
              <img src={middleIcon} alt="" className="middleIcon" />
              <img src={topIcon} alt="" className="topIcon" />
            </div>
            <div className="ml24">
              <div className="text1">年处理水量</div>
              <div className="font24 numberFont flex alignItemEnd">
                {data["yearLJLL"] ? (
                  <ScrollNumber data={data["yearLJLL"]}></ScrollNumber>
                ) : (
                  "--"
                )}
                <span
                  className="text1"
                  style={{ lineHeight: "34px", marginLeft: 5 }}
                >
                  m³
                </span>
              </div>
            </div>
          </div>
          <div className="flex flexBetween alignItemCenter mt22">
            <Block
              icon={<img src={static_01} />}
              label="总瞬时流量"
              value={data.SSLL}
              unit="m³/h"
            />
            <Block
              icon={<img src={static_02} />}
              label="日处理水量"
              value={data.dayLJLL}
              unit="m³"
            />
            <Block
              icon={<img src={static_03} />}
              label="月处理水量"
              value={data.monthLJLL}
              unit="m³"
            />
          </div>
        </div>
      </div>

      <Divider />
      <div>
        <div className="flex flexBetween">
          <Block2
            title="巡检任务统计"
            data={xunjian_data}
            option={xunjian_option}
          />
          <Block2
            title="缺陷单统计"
            data={quexian_data}
            option={xunjian_option2}
          />
        </div>
        <div className="flex flexBetween mt34">
          <Block2
            title="工单统计"
            data={gongdan_data}
            option={xunjian_option3}
          />
          <Block2
            title="设备完好率"
            data={device_data}
            option={xunjian_option4}
          />
        </div>
      </div>

      <Divider />

      <div className="shuizhi_wrapper flex">
        <div>
          <SubTitle
            title="厂站水质达标趋势图"
            style={{ marginBottom: "10px" }}
          />
          <div className="flex">
            {/* <div className="flexColumn alignItemCenter">
              {shuizhi &&
                shuizhi.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`shuizhi_b ${
                        (shuizhi_active === index && isPoll) ||
                        (shuizhi_click === index && !isPoll)
                          ? "shuizhi_b_active"
                          : ""
                      }`}
                      onClick={() => changeIndex(index)}
                    >
                      {item}
                    </div>
                  );
                })}
            </div> */}
            <div style={{ width: "394px", height: "200px" }}>
              <Ocharts data={chartData} />
              {/* <CommonlyChart
                option={shuizhi_option}
                height={170}
                width={320}
              ></CommonlyChart> */}
            </div>
          </div>
        </div>
      </div>
      <div className="flexColumn">
        <SubTitle title="厂站能耗数据分析" style={{ marginBottom: "10px" }}>
          <Tab data={["月", "年"]} onChange={changeNenghaoActive} />
        </SubTitle>
        <div>
          <CommonlyChart
            option={nenghao_option}
            height={170}
            width={320}
          ></CommonlyChart>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};
export default connect(mapStateToProps)(Index);
